'use strict';

var React = require('react');
var assetsHelper = require('../../helper/assetsHelper');
var util = require('../../helper/util');
var styleHelper = require('../../helper/styleHelper');
var Shape = require('./Shape.jsx');
var Icon = require('./Icon.jsx');
/**
 * 头像
 */
var AvatarEx = React.createClass({
  render: function () {
    var iconStyle = {
      width: this.props.children[1].props.w,
      height: this.props.children[1].props.h,
      marginLeft: this.props.children[1].props.x,
      marginTop: this.props.children[1].props.y-1,
      position: 'absolute'
    };
      var icon = this.props.children[1].props.icon;
        var iconProps = this.props.children[1].props;
      if(icon.iconCode === '62168' && icon.iconFontName === 'jdIonicons') {
          iconStyle.width = Math.round(iconStyle.width*9/7);
          iconStyle.height = Math.round(iconStyle.height*9/7);
          iconStyle.marginLeft = Math.round((this.props.w - iconStyle.width)/2);
          iconStyle.marginTop = this.props.h-Math.round(iconStyle.height*8/9)-this.props.children[0].props.thickness+1;
      }
    return (
        <div>
          <Shape {...this.props.children[0].props}
              key={this.props.children[0].key}></Shape>
          <div style={iconStyle}>
            <Icon {...iconProps}
                w={iconStyle.width}
                h={iconStyle.height}
                key={this.props.children[1].key}></Icon>
          </div>
        </div>
    );
  }
});

module.exports = AvatarEx;



// WEBPACK FOOTER //
// ./src/views/Components/AvatarEx.jsx